import { WrapperTwoLayout } from '@/components/Layouts';
import {
  Image_Subtypes_Enum,
  useGetBannerQuery,
  useGetPostByIdQuery,
} from '@/generated/graphql';
import format from '@/utils/format';
import { useRouter } from 'next/router';
import React from 'react';
import {
  ContentDetailSection,
  ReadMoreSection,
  RelatedCategory,
  RightSideBar,
} from '@/components/PostDetail';
import { GetBannerDetailPostParams } from '@/constants/defaultParams';
import { Banner, BannerCustomizeHeight, Divider } from '../Shared';

const DetailPostPage = () => {
  const router = useRouter();
  const { slug: postSlug } = router.query;
  const id = format.convertUrlToId(postSlug?.[1]?.toString() || '');

  const { data } = useGetPostByIdQuery({
    variables: {
      postsByPkId: Number(id),
    },
  });

  const { slug, title, postsCategories } = data?.postsByPk || {};

  const slugCategory = postsCategories?.[0]?.category?.slug;

  const formatSlug = slug
    ? `/${slugCategory}/${slug}-${id}`
    : `/${slugCategory}/${format.convertTitleToSlug(title as string)}-${id}`;

  if (typeof window !== 'undefined' && router?.asPath !== formatSlug) {
    router.replace(formatSlug);
  }
  const { data: dataBanner } = useGetBannerQuery({
    variables: GetBannerDetailPostParams,
  });
  return (
    <>
      <div
        style={{
          animation: 'animate-fadein 0.5s ease-in-out',
        }}
        className="container relative"
      >
        <WrapperTwoLayout
          leftColumn={<ContentDetailSection data={data || {}} />}
          rightColumn={<RightSideBar />}
        />
        <div className="w-full">
          <BannerCustomizeHeight
            data={dataBanner?.banners.filter(
              item => item.position === Image_Subtypes_Enum.PostDetailBottom,
            )}
          />
        </div>
        <Divider />
        <WrapperTwoLayout
          leftColumn={
            <ReadMoreSection
              idPost={data?.postsByPk?.id}
              categoryId={
                data?.postsByPk?.postsCategories &&
                data?.postsByPk?.postsCategories[0]?.category?.id
              }
            />
          }
          rightColumn={
            <RelatedCategory
              fullSlug={
                data?.postsByPk?.postsCategories &&
                data?.postsByPk?.postsCategories?.[0]?.category?.path_full_slug
                  ?.full_slug
              }
            />
          }
        />
        <div className="flex gap-5 my-4">
          <div className="w-full h-[36vw] lg:h-[465px]">
            <Banner
              data={dataBanner?.banners.filter(
                item => item.position === Image_Subtypes_Enum.SearchBottom_1,
              )}
            />
          </div>
          <div className="w-full h-[36vw] lg:h-[465px]">
            <Banner
              data={dataBanner?.banners.filter(
                item => item.position === Image_Subtypes_Enum.SearchBottom_2,
              )}
            />
          </div>
          <div className="w-full h-[36vw] lg:h-[465px]">
            <Banner
              data={dataBanner?.banners.filter(
                item => item.position === Image_Subtypes_Enum.SearchBottom_3,
              )}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default DetailPostPage;
